export const API_URL = process.env.REACT_APP_API_URL || "";
export const JSON_URL = process.env.REACT_APP_JSON_URL || "";
export const SENTRY_DSN_URL = process.env.REACT_APP_SENTRY_DSN_URL;
export const SQUAD_IMAGE_URL = process.env.REACT_APP_SQUAD_IMAGE_URL || "/squads/";
export const ODDS_DISABLED = process.env.REACT_APP_ODDS_DISABLED === "true";

const REACT_APP_DISABLE_COUNTRY_CHECK = process.env.REACT_APP_DISABLE_COUNTRY_CHECK === "true";

const QUERY_DISABLE_COUNTRY_CHECK =
	new URLSearchParams(window.location.search).get("DISABLE_COUNTRY_CHECK") === "true";

export const DISABLE_COUNTRY_CHECK = REACT_APP_DISABLE_COUNTRY_CHECK || QUERY_DISABLE_COUNTRY_CHECK;

export const LIVE_SCORING_FETCH_TIMING = 10 * 1000;

export const PRE_SEASON_ROUND_MAP: Record<string, string> = {
	1: "A",
	2: "B",
	3: "C",
	4: "D",
	5: "E",
};

export const FINALS_ROUND_START = 22;
export const GREY_CUP_ROUND_NUMBER = 26;
